import React, { Component } from "react";
import './ToggleSwitch.css';

class ToggleSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: props.isChecked,
    };
    
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange() {
    this.setState({ isChecked: !this.state.isChecked })
    
  }
  render () {
    return (
      <label className="switch">
        <input type="checkbox" className={this.props.className} checked={this.state.isChecked}
        onChange={this.handleChange} />
        <div className="slider"></div>
      </label>
    );
  }
}

export default ToggleSwitch;